export const T = {
  en_GB: {
    noPortfolioCostsConfigured: "No portfolio costs configured for this collection.",
    recurring: "Recurring",
    onDeposit: "On Deposit",
    onWithdrawal: "On Withdrawal",
    percentageBasedFee: "Percentage-based fee",
    fixedAmountFee: "Fixed amount fee",
    portfolioValue: "Portfolio Value",
    rate: "Rate",
    fee: "Fee",
    category: "Category",
    tiered: "(tiered)",
    overrideFee: (fee: string) => `Override ${fee}`,
  },
  nb_NO: {
    noPortfolioCostsConfigured: "Ingen porteføljekostnader konfigurert for denne samlingen.",
    recurring: "Løpende",
    onDeposit: "Ved innskudd",
    onWithdrawal: "Ved uttak",
    percentageBasedFee: "Prosentbasert gebyr",
    fixedAmountFee: "Fast beløp",
    portfolioValue: "Porteføljeverdi",
    rate: "Sats",
    fee: "Gebyr",
    category: "Kategori",
    tiered: "(trappetrinn)",
    overrideFee: (fee: string) => `Overstyr ${fee}`,
  },
} as const;
